import {FC} from 'react';
import {useParams} from 'wouter';

import {DoorTabs} from '@mavismart_frontend/pages/door_tabs';
import {GroupTabs} from '@mavismart_frontend/pages/group_tabs';
import {HomeTabs} from '@mavismart_frontend/pages/home_tabs';

export const MobileHome: FC = () => {
  const {groupId, doorId} = useParams<{groupId?: string; doorId?: string}>();
  return doorId ? (
    <DoorTabs
      doorId={doorId}
      baseUrl={groupId ? `/groups/${groupId}/doors/${doorId}` : `/doors/${doorId}`}
    />
  ) : groupId ? (
    <GroupTabs />
  ) : (
    <HomeTabs />
  );
};

MobileHome.displayName = 'MobileHome';
